/**
 * A Map with a size limit. When the limit is exceeded, oldest entries are evicted (FIFO).
 */
export class MapForCache<K, V> extends Map<K, V> {
  sizeLimit = 10000;

  static newWithLimit<K, V>(limit: number) {
    const instance = new MapForCache<K, V>();
    instance.sizeLimit = limit;
    return instance;
  }

  set(key: K, val: V) {
    super.set(key, val);

    for (const [k] of this) {
      if (this.size <= this.sizeLimit) break;
      this.delete(k);
    }

    return this;
  }
}
